import {latLng, MapOptions, tileLayer} from "leaflet";
import {LorenMap} from "../loren-map/constants/loren-map.constants";
import {cloneDeep, merge} from "lodash-es";

export const mapDefaults: MapOptions = Object.freeze({
    layers: [
        tileLayer(LorenMap.urlTemplate, {
            maxZoom: LorenMap.maxZoom,
        }),
    ],
    attributionControl: false,
    zoom: 3,
    center: latLng(51.505, 10.451), // Roughly center of Europe - Germany
});

export function getMapDefaults(options: MapOptions = {}) {
    // The leaflet library mutates the state of this so we need to create a new config object for every map
    return merge(cloneDeep(mapDefaults), cloneDeep(options));
}